var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel"},[_c('el-carousel',{attrs:{"interval":5000,"height":"150px"}},_vm._l((_vm.list),function(item,i){return _c('el-carousel-item',{key:i},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":item.img},on:{"click":function($event){_vm.openHref(item.url)}}})])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e518220","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/EventIndex/HomePage/components/CarouselBanner.vue
// module id = null
// module chunks = 